function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.48 87.24",
    stroke: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "54737390-5a59-475a-81a6-9c994896172b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9f07a18d-6be6-43df-bc50-3cadda395f9c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.86,10A33.67,33.67,0,0,0,11.42,24.22a4,4,0,0,1-5.17,1.2l-.1-.06a4,4,0,0,1-1.28-5.75A41.61,41.61,0,1,1,2,63",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,32.33l1.16,24A1.52,1.52,0,0,1,60.81,58L20.09,60a1.53,1.53,0,0,1-1.46-1.57l-1.16-24a1.52,1.52,0,0,1,1.31-1.7l40.72-2A1.53,1.53,0,0,1,61,32.33Z",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.88,33.18,38.67,49.32a2,2,0,0,0,2.62-.13l8.83-8.33,10.31-9.73",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email2.6914dcaf.svg";
export { ForwardRef as ReactComponent };